import { HttpClient, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { ColumnDefinitionDto, MemberDto, ProductSearchDto, ResultListDto } from "./dto";
import { InsurancePremiumRecipientDto, PolicyCreatePayload, PolicyDto, ProductDto, PolicyScheduleUploadDto } from "./dto-insurance";

@Injectable({
	providedIn: 'root'
})
export class HttpInsurancePolicyService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/insurance/policy', authService);
	}

	public get(id: number): Observable<PolicyDto>{
		return super.doGet(true,`/${id}`);
	}
	public create(input: PolicyDto): Observable<PolicyDto>{
		return super.doPost(true,'/',input);
	}
	public update(id: number, input: PolicyDto): Observable<PolicyDto>{
		return super.doPost(true,`/${id}`,input);
	}
	public search(phrase: string): Observable<PolicyDto[]>{
		return super.doGet(true, `/search?phrase=${encodeURIComponent(phrase)}`);
	}
	public findByMember(id: number): Observable<PolicyDto[]>{
		return super.doGet(true,`/member:${id}`);
	}

}
